import MainLayout from '../../components/layouts/mainLayout';

const PrivacyPolicy = () => {
    return (
        <MainLayout>
            <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-5 text-start mb-5">
                <h1 className="text-3xl font-bold text-primary mb-6">Privacy Policy</h1>
                <p className="text-secondary mb-4">
                    Effective Date:  01/01/2025
                </p>
                <p className="text-secondary mb-4">
                    Welcome to INVETIX POS. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our services.
                </p>

                <h2 className="text-xl font-semibold mt-6">1. Information We Collect</h2>
                <p className="text-secondary">
                    We collect the following types of information:
                    <ul className="list-disc pl-6">
                        <li><strong>Personal Information:</strong> Name, email address, phone number, business details, and payment information when you sign up for our services.</li>
                        <li><strong>Usage Data:</strong> Information about your interactions with our website and services, including IP address, device type, browser type, and session details.</li>
                        <li><strong>Transactional Data:</strong> Details of transactions processed through our POS system, including customer details and payment records.</li>
                        <li><strong>Cookies & Tracking Data:</strong> We use cookies and similar tracking technologies to improve user experience and analyze trends.</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6">2. How We Use Your Information</h2>
                <p className="text-secondary">
                    We use your information for the following purposes:
                    <ul className="list-disc pl-6">
                        <li>To provide, maintain, and improve our services.</li>
                        <li>To process transactions and send invoices.</li>
                        <li>To communicate with you regarding updates, promotions, or customer support.</li>
                        <li>To analyze usage and optimize our platform.</li>
                        <li>To comply with legal obligations and enforce our Terms & Conditions.</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6">3. Data Protection and Security</h2>
                <p className="text-secondary">
                    We implement strict security measures to protect your data, including encryption, secure servers, and access control. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                </p>

                <h2 className="text-xl font-semibold mt-6">4. Sharing of Information</h2>
                <p className="text-secondary">
                    We do not sell, rent, or trade your personal data. However, we may share information with:
                    <ul className="list-disc pl-6">
                        <li><strong>Service Providers:</strong> Trusted third-party providers who assist in operating our platform (e.g., payment processors, hosting services).</li>
                        <li><strong>Legal Compliance:</strong> When required by law or to protect our rights and the security of our users.</li>
                        <li><strong>Business Transfers:</strong> In case of a merger, sale, or acquisition, user data may be transferred to the new entity.</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6">5. Your Rights and Choices</h2>
                <p className="text-secondary">
                    - You can access, update, or delete your personal information by contacting us.<br />
                    - You can opt out of promotional emails at any time.<br />
                    - You may disable cookies in your browser settings, though this may affect functionality.
                </p>

                <h2 className="text-xl font-semibold mt-6">6. Data Retention</h2>
                <p className="text-secondary">
                    We retain your data for as long as necessary to provide our services and comply with legal requirements. Once no longer needed, we securely delete or anonymize your data.
                </p>

                <h2 className="text-xl font-semibold mt-6">7. Third-Party Links</h2>
                <p className="text-secondary">
                    Our platform may contain links to third-party websites. We are not responsible for their privacy practices and encourage you to review their policies.
                </p>

                <h2 className="text-xl font-semibold mt-6">8. Children’s Privacy</h2>
                <p className="text-secondary">
                    Our services are not intended for individuals under 18. We do not knowingly collect personal data from minors.
                </p>

                <h2 className="text-xl font-semibold mt-6">9. Changes to This Privacy Policy</h2>
                <p className="text-secondary">
                    We may update this policy from time to time. Any changes will be posted on our website, and we encourage you to review this policy periodically.
                </p>

                <h2 className="text-xl font-semibold mt-6">10. Contact Us</h2>
                <p className="text-secondary">
                    If you have any questions or concerns about this Privacy Policy, please contact us at:
                </p>
                <p className="text-secondary">
                    <strong>INVETIX POS</strong><br />
                    {/* [Your Business Address]<br /> */}
                    Email: [support@invetix.in]<br />
                    {/* Phone: [Your Contact Number] */}
                </p>
            </div>
        </MainLayout>
    );
};

export default PrivacyPolicy;
